import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

// One-off because this field cannot be mapped and is not a custom field
export function CompanyNameField() {
    return (
        <StackLegacy spacing={8}>
            <Body size='small'>
                This field maps to the <strong>Company name</strong>&nbsp;field in Nutshell.
            </Body>
        </StackLegacy>
    );
}
